import React, { useState, useEffect } from 'react';

const PageTransition = ({ children, isTransitioning, onTransitionComplete }) => {
  const [showTransition, setShowTransition] = useState(false);

  useEffect(() => {
    if (isTransitioning) {
      setShowTransition(true);
      // Start the transition animation
      const timer = setTimeout(() => {
        setShowTransition(false);
        onTransitionComplete();
      }, 1000); // Duration of the transition

      return () => clearTimeout(timer);
    }
  }, [isTransitioning, onTransitionComplete]);

  return (
    <div className="page-transition-container">
      {children}
      {showTransition && (
        <div className="page-transition-overlay">
          <div className="transition-dot"></div>
        </div>
      )}
    </div>
  );
};

export default PageTransition;
